import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';
import { getJiraAppLinksUrl } from '@atlassian/jira-issue-view-services/src/issue/issue-urls.tsx';
import type { BaseUrl, IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

export const fetchJiraAppLink = (baseUrl: BaseUrl, issueKey: IssueKey) =>
	fetchJson$(getJiraAppLinksUrl(baseUrl, issueKey));

export default fetchJiraAppLink;
